/**
 * Server PDF download UI + optional auto-download after generation.
 *
 * Precedence (first match wins):
 * 1. API `GET /api/public-config` → `features.serverPdfDownloadEnabled` (boolean) — runtime toggle without rebuild
 * 2. `REACT_APP_ENABLE_SERVER_PDF_DOWNLOAD=1` in the frontend build env
 */
export function resolveServerPdfDownloadEnabled(publicConfig) {
  const f = publicConfig?.features;
  if (f && typeof f.serverPdfDownloadEnabled === 'boolean') return f.serverPdfDownloadEnabled;
  if (f && String(f.serverPdfDownloadEnabled).trim() === '1') return true;
  if (f && String(f.serverPdfDownloadEnabled).trim() === '0') return false;
  return String(process.env.REACT_APP_ENABLE_SERVER_PDF_DOWNLOAD || '').trim() === '1';
}

/**
 * After a successful server PDF generation, optionally auto-start a file download (assessment result).
 * Precedence: `features.autoDownloadPdfAfterGenerate` from public-config, then `REACT_APP_AUTO_DOWNLOAD_PDF_AFTER_GENERATE=1`.
 * Separate from {@link resolveServerPdfDownloadEnabled} at config level; the assessment page only triggers auto-download
 * when server PDF download is enabled as well.
 */
export function resolveAutoDownloadPdfAfterGenerate(publicConfig) {
  const f = publicConfig?.features;
  if (f && typeof f.autoDownloadPdfAfterGenerate === 'boolean') return f.autoDownloadPdfAfterGenerate;
  if (f && String(f.autoDownloadPdfAfterGenerate).trim() === '1') return true;
  if (f && String(f.autoDownloadPdfAfterGenerate).trim() === '0') return false;
  return String(process.env.REACT_APP_AUTO_DOWNLOAD_PDF_AFTER_GENERATE || '').trim() === '1';
}
